var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAdditionalHeaders } from "./actions.mjs";
import { completeInvoicePurchaseResponseSchema } from "./cart/index.mjs";
import { postWithRetries } from "./http.mjs";
import { logger } from "./log.mjs";
export const completeInvoicePurchase = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const request = {
            recaptchaToken: yield actions.getRecaptchaToken(),
            trackingCookies: state.trackingCookies,
        };
        yield postWithRetries(`/carts/${state.id}/${state.version}/complete-invoice-purchase`, state.checkoutApiBaseUrl, request, completeInvoicePurchaseResponseSchema, state.token, getAdditionalHeaders(state));
    }
    catch (error) {
        logger.error({ error }, 'An unexpected error occurred');
        state.onUnexpectedError('An unexpected error occurred');
    }
});
//# sourceMappingURL=completeInvoicePurchase.js.map